import {
  Button,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import { IconButton, InformationModal, Switch } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  checked: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onChange: () => Promise<void>
}

export const PrivacySettingsTemplate: Template<State, Action> = ({
  state,
  onChange,
}) => {
  const { t } = useTranslation('privacySettings')
  const { routerNames, routerPages } = useRouter()
  const [open, setOpen] = useState<boolean>(false)
  return (
    <>
      <Head title={routerNames.PrivacySettings} />
      <BaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.Setting,
          title: t('title'),
        }}
      >
        <List>
          <ListItem
            divider
            sx={{ bgcolor: 'grey.50' }}
            secondaryAction={
              <Switch checked={state.checked} onChange={onChange} />
            }
          >
            <ListItemText
              primary={
                <Stack direction="row" alignItems="center">
                  <Typography variant="body1">
                    {t('hiddenOwnedItems')}
                  </Typography>
                  <IconButton.Help size="small" onClick={() => setOpen(true)} />
                </Stack>
              }
            />
          </ListItem>
        </List>
        <InformationModal
          open={open}
          onClose={() => setOpen(false)}
          title={t('hiddenOwnedItemsTitle')}
          content={t('hiddenOwnedItemsDesc')}
          buttons={
            <Button
              size="large"
              sx={{ width: 212 }}
              onClick={() => setOpen(false)}
            >
              {t('ok')}
            </Button>
          }
        />
      </BaseLayout>
    </>
  )
}
